import * as React from 'react';
import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement> & { error?: string }>(
  ({ className, error, ...props }, ref) => (
    <div className="w-full">
      <textarea ref={ref} className={cn('flex min-h-[100px] w-full rounded-md border border-border bg-background px-3 py-2 text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring resize-none', error && 'border-destructive', className)} {...props} />
      {error && <p className="mt-1 text-xs text-destructive">{error}</p>}
    </div>
  )
);
Textarea.displayName = 'Textarea';
export { Textarea };
